import isEmpty from "lodash/isEmpty";
import {
  CLEAR_SESSION_EXPIRED,
  LOGIN_FAILURE,
  LOGOUT,
  SESSION_CHECK_START,
  SESSION_EXPIRED,
  SESSION_OK,
  SET_CURRENT_USER,
  SET_EMAIL_FOR_VERIFICATION,
  SIGNUP_SUCCESS,
  VERIFY_FAILURE,
  VERIFY_REQUEST,
  VERIFY_SUCCESS,
} from "../Actions/types";

const initialState = {
  isAuthenticated: false,
  verification: null,
  pendingEmail: null,
  sessionExpired: false,
  sessionChecked: false,
  loading: false,
  user: {},
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGNUP_SUCCESS:
      return {
        ...state,
        user: action.payload,
        pendingEmail: action.payload.userEmail,
        error: null,
      };
    case SET_EMAIL_FOR_VERIFICATION:
      return {
        ...state,
        pendingEmail: action.payload,
        error: null,
      };
    case VERIFY_REQUEST:
      return { ...state, loading: true, error: null };

    case VERIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        verification: action.payload,
        error: null,
      };

    case VERIFY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Verification failed",
      };
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.payload),
        user: {
          ...action.payload,
          name: action.payload.profileName || state.user.name, // Ensure profileName is set
        },
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        user: {},
        error: action.payload,
      };
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: {},
        error: null,
      };
    case SESSION_CHECK_START:
      return {
        ...state,
        loading: true,
      };
    case SESSION_OK:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        sessionExpired: false,
        sessionChecked: true,
      };
    case SESSION_EXPIRED:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        sessionExpired: true,
        sessionChecked: true,
      };
    case CLEAR_SESSION_EXPIRED:
      return {
        ...state,
        sessionExpired: false,
      };
    default:
      return state;
  }
};

export default authReducer;
